import { render, staticRenderFns } from "./BindCoupon.vue?vue&type=template&id=6ba7e430&scoped=true"
import script from "./BindCoupon.vue?vue&type=script&lang=js"
export * from "./BindCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7e430",
  null
  
)

export default component.exports